import { render, staticRenderFns } from "./LabelEdit.vue?vue&type=template&id=29d2f090&"
import script from "./LabelEdit.vue?vue&type=script&lang=js&"
export * from "./LabelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports